import { isEmpty } from 'lodash-es';

export const createCorrectnessText = points => {
  if (points === 1) {
    return 'correct';
  }

  if (points === 0) {
    return 'incorrect';
  }

  if (points > 0 && points < 1) {
    return 'partially correct';
  }

  return 'unanswered';
};

export const getPercentage = (studentsNumber, allStudentsAnsweredNr) => {
  const studentsNr = studentsNumber || 0;
  const studentsAnsweredNr = allStudentsAnsweredNr || 1;

  return Math.round((studentsNr * 100) / studentsAnsweredNr);
};

export const latexToHTML = latex =>
  `<span data-latex='' data-raw='${latex}'>
    ${latex}
   </span>`;

export const isMultiPartMER = item => {
  const { elements } = item || {};

  if (!elements || isEmpty(elements) || Object.keys(elements).length !== 1) {
    return false;
  }

  const elementMarkupTag = Object.keys(elements)[0];
  const tag = elements[elementMarkupTag];
  const RE_SCOPED = /^(@[^/]+\/[^/@]+)(?:\/([^@]+))?(?:@([\s\S]+))?/;
  const RE_NORMAL = /^([^/@]+)(?:\/([^@]+))?(?:@([\s\S]+))?/;
  const matched =
    tag.charAt(0) === '@' ? tag.match(RE_SCOPED) : tag.match(RE_NORMAL);

  const elementPackageName = matched[1];
  const elementTag = elementPackageName.split('/')[1] || '';

  return elementTag === 'math-inline';
};
